module.exports = __webpack_public_path__ + "img/autumn.016c9eb1.jpg";